import { Token } from '../token';
import { Constructor, IKb3dModel } from './model-utils';

export interface IInjectParameter {
    classConstructor: Constructor<any>;
    token: Token;
    parameterIndex: number;
    ignore: boolean;
}

export const injectParameters: any[] = [];

export function Inject(token: Token) {
    return (target: Constructor<any>, propertyKey: undefined, parameterIndex: number) => {
        injectParameters.push({
            token: token,
            classConstructor: target,
            parameterIndex,
            ignore: false,
        });
    };
}

export function Ignore() {
    return (target: Constructor<any>, propertyKey: undefined, parameterIndex: number) => {
        injectParameters.push({
            token: Token.Ignore,
            classConstructor: target,
            parameterIndex,
            ignore: true,
        });
    };
}

export function getConstructorParamsForModel<T>(modelDef: IKb3dModel<T>): IInjectParameter[] {
    let constructor: any;
    if (modelDef.trackChanges) {
        constructor = Object.getPrototypeOf(modelDef.classConstructor);
    } else {
        constructor = modelDef.classConstructor;
    }
    const paramsForType = injectParameters.filter(i => i.classConstructor == constructor);

    paramsForType.sortBy(p => p.index);
    if (modelDef.classConstructor && paramsForType.length < modelDef.classConstructor.length) {
        throw new Error(
            'You must decorate every constructor parameter with an @Inject or @Ignore decorator for type ' +
                modelDef.token.key
        );
    }
    return paramsForType;
}
